import initialState from "../initial-state";
import {
  MOSTRAR_MONITOREO_EVALUACIONES,
  MOSTRAR_MONITOREO_EVALUACION,
  LOADING_MONITOREO_EVALUACION,
  MONITOREO_EVALUACION_FAILED,
  CREAR_MONITOREO_EVALUACION,
  ACTUALIZAR_MONITOREO_EVALUACION,
  MONITOREO_EVALUACION_SUCCEEDED,
} from "../types";

const { monitoreoEvaluaciones } = initialState;

const normalizarLista = (payload) =>
  (Array.isArray(payload) ? payload : [payload]).filter(Boolean);

const mismaEvaluacion = (a, b) => {
  if (a.monitoreoEvaluacionId && b.monitoreoEvaluacionId) {
    return a.monitoreoEvaluacionId === b.monitoreoEvaluacionId;
  }

  return a.monitoreoId === b.monitoreoId && a.criterioId === b.criterioId;
};

const upsertEvaluaciones = (actuales, payload) => {
  const nuevas = normalizarLista(payload);

  return nuevas.reduce((lista, evaluacion) => {
    const index = lista.findIndex((item) => mismaEvaluacion(item, evaluacion));

    if (index === -1) {
      return [...lista, evaluacion];
    }

    return lista.map((item, itemIndex) =>
      itemIndex === index ? { ...item, ...evaluacion } : item
    );
  }, actuales);
};

export const MonitoreoEvaluacionReducer = (
  state = monitoreoEvaluaciones,
  action
) => {
  switch (action.type) {
    case LOADING_MONITOREO_EVALUACION:
      return {
        ...state,
        isLoading: true,
      };
    case MOSTRAR_MONITOREO_EVALUACION:
      return {
        ...state,
        monitoreoEvaluacion: action.payload,
        isLoading: false,
      };
    case MOSTRAR_MONITOREO_EVALUACIONES:
      return {
        ...state,
        monitoreoEvaluaciones: action.payload,
        isLoading: false,
      };
    case CREAR_MONITOREO_EVALUACION:
    case ACTUALIZAR_MONITOREO_EVALUACION:
      return {
        ...state,
        monitoreoEvaluacion: action.payload,
        monitoreoEvaluaciones: upsertEvaluaciones(
          state.monitoreoEvaluaciones,
          action.payload
        ),
        isLoading: false,
      };
    case MONITOREO_EVALUACION_SUCCEEDED:
    case MONITOREO_EVALUACION_FAILED:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
};
